(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3640],{

/***/ 13932:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-trial",
      function () {
        return __webpack_require__(86023);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 64576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "free-trial": __webpack_require__(85562)
};


/***/ }),

/***/ 42012:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(64576),
    de: __webpack_require__(27340)
};


/***/ }),

/***/ 86023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ free_trial; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/i18/index.js + 16 modules
var i18 = __webpack_require__(46003);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js + 3 modules
var SimpleTemplate = __webpack_require__(35449);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Title.js
var Title = __webpack_require__(70504);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Description.js
var Description = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/Form.js
var Form = __webpack_require__(3361);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/Html/index.js
var Html = __webpack_require__(73972);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/props-resolver.js
var props_resolver = __webpack_require__(77915);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/google-recaptcha/index.js + 4 modules
var google_recaptcha = __webpack_require__(43579);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/routes.js + 1 modules
var routes = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/SmartForm/index.js + 8 modules
var SmartForm = __webpack_require__(3816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Spinner/index.js + 1 modules
var Spinner = __webpack_require__(39116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/validation/index.js + 6 modules
var validation = __webpack_require__(89965);
;// CONCATENATED MODULE: ./src/FreeTrialForm/form.js

const initialState = {
    email: ""
};
const schema = {
    email: [
        [
            validation/* required */.C1,
            "errors.EMAIL_REQUIRED"
        ],
        [
            (0,validation/* isCorrectEmailLen */.jh)(64),
            "errors.EMAIL_INVALID_LENGTH"
        ],
        [
            validation/* isEmail */.Jh,
            "errors.WRONG_EMAIL"
        ]
    ]
};
const validateForm = (0,validation/* default */.ZP)(schema);

// EXTERNAL MODULE: ./src/utils/useResultStatus/index.js
var useResultStatus = __webpack_require__(4116);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./src/services/trial.js + 4 modules
var trial = __webpack_require__(46835);
// EXTERNAL MODULE: ./src/apollo/operation-errors.js
var operation_errors = __webpack_require__(99092);
// EXTERNAL MODULE: ./src/nprogress.js
var nprogress = __webpack_require__(24753);
// EXTERNAL MODULE: ./src/persistent-storage/index.js + 2 modules
var persistent_storage = __webpack_require__(11095);
;// CONCATENATED MODULE: ./src/FreeTrialForm/action.js







const navToPathWithSettledTokens = (token, refreshToken, trialId)=>{
    (0,persistent_storage/* Token */.WU)().set(token);
    (0,persistent_storage/* RefreshToken */.E6)().write(refreshToken);
    (0,routes/* toCompleteProfilePage */.oL)(trialId);
};
const navToCompleteProfilePage = (token, refreshToken, trialId)=>token && refreshToken ? navToPathWithSettledTokens(token, refreshToken, trialId) : (0,routes/* toCompleteProfilePage */.oL)(trialId);
const handleSuccess = (param)=>{
    let { trialId , isAuthorized , token , refreshToken  } = param;
    return !isAuthorized ? (0,routes/* navToPath */.SS)(routes/* default.confirmEmail */.ZP.confirmEmail) : navToCompleteProfilePage(token, refreshToken, trialId);
};
/** @type {(form: { email: string }, turingToken: string) => Promise<void>} */ const requestTrial = (form, turingToken)=>(0,trial/* requestFreeTrial */.WB)(form, turingToken).then(handleSuccess).catch((0,fn/* mapErrors */.wc)(operation_errors/* default */.ZP));
/* harmony default export */ var FreeTrialForm_action = ((0,pipe/* default */.Z)(requestTrial, (0,nprogress/* withLoading */.VT)("request-trial")));

// EXTERNAL MODULE: ./src/utils/FlashMessage/index.js
var FlashMessage = __webpack_require__(3812);
;// CONCATENATED MODULE: ./src/FreeTrialForm/index.js














const FreeTrialForm = (param)=>{
    let { trialTokenExpired  } = param;
    const [t] = (0,i18/* useLocale */.bU)("free-trial");
    const [requestTrialAction, isRequestProcessing] = (0,useTracking/* default */.ZP)(FreeTrialForm_action, useTracking/* CATCH */.av);
    const [action, { errors  }, resetResult] = (0,useResultStatus/* default */.Z)(requestTrialAction);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isRequestProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}),
            trialTokenExpired && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashMessage/* default */.Z, {
                text: t("errors.EXPIRED_TOKEN")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmartForm/* default */.ZP, {
                textRender: t,
                initialState: initialState,
                validateForm: validateForm,
                action,
                onTouched: resetResult,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SmartForm/* default.Field */.ZP.Field, {
                        label: "EMAIL",
                        name: "email",
                        type: "email",
                        disabled: isRequestProcessing,
                        error: errors.code === "TURING_TEST_FAILED" ? "errors.TURING_TEST_FAILED" : errors.message,
                        fieldClassName: "mb-8",
                        required: true,
                        "data-qa-selector": "free-trial-email-input"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            spacing: {
                                mt: 4,
                                mb: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                                sx: {
                                    textAlign: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    disabled: isRequestProcessing,
                                    "data-qa-selector": "free-trial-submit-button",
                                    children: t("SUBMIT")
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
FreeTrialForm.propTypes = {
    trialTokenExpired: prop_types.string
};
/* harmony default export */ var src_FreeTrialForm = (FreeTrialForm);

// EXTERNAL MODULE: ./src/SiteLayout/index.js + 5 modules
var SiteLayout = __webpack_require__(3918);
// EXTERNAL MODULE: ./locales/free-trial-page/index.js
var free_trial_page = __webpack_require__(42012);
var free_trial_page_default = /*#__PURE__*/__webpack_require__.n(free_trial_page);
;// CONCATENATED MODULE: ./pages/free-trial/index.js


















const FreeTrial = (param)=>{
    let { expired  } = param;
    const [t] = (0,i18/* useLocale */.bU)("free-trial");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META.TITLE"),
                description: t("META.DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        locale: t("META.LOCALE"),
                        type: t("META.TYPE"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        url: t("META.URL"),
                        image: t("META_IMAGE"),
                        imageSecureUrl: t("META_IMAGE_SECURE"),
                        siteName: t("META.SITE_NAME"),
                        articlePublisher: t("META.ARTICLE_PUBLISHER"),
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: t("META.CANONICAL")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Twitter */.ZP.Twitter, {
                        card: t("META.TWITTER_CARD"),
                        title: t("META.TITLE"),
                        description: t("META.DESCRIPTION"),
                        site: t("META.TWITTER_SITE"),
                        creator: t("META.TWITTER_CREATOR"),
                        image: t("META_TWITTER_IMAGE"),
                        isImageBaseUrl: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleTemplate/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        className: "px-3",
                        "data-qa-selector": "free-trial-main-heading",
                        children: t("TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        "data-qa-selector": "free-trial-description-paragraph",
                        children: t("SUB_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_FreeTrialForm, {
                            trialTokenExpired: expired
                        }, Math.random())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        sx: {
                            fontSize: "xs",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Html/* default */.Z, {
                            Tag: "span",
                            children: t("AGREEMENT", {
                                tosLink: routes/* default.external.termsOfService */.ZP.external.termsOfService,
                                ppLink: routes/* default.external.privacyPolicy */.ZP.external.privacyPolicy
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("center", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(google_recaptcha/* GoogleRecaptchaNotice */.Wl, {})
                    })
                ]
            })
        ]
    });
};
const expired = (param)=>{
    let { query  } = param;
    return query.expired;
};
FreeTrial.propTypes = {
    expired: prop_types.string
};
FreeTrial.getInitialProps = (0,props_resolver/* default */.Z)({
    expired
});
/* harmony default export */ var free_trial = ((0,pipe/* default */.Z)(FreeTrial, (0,i18/* WithLocale */._t)({
    resources: (free_trial_page_default())
})));


/***/ }),

/***/ 99092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ getExceptionFields; },
/* harmony export */   "ZU": function() { return /* binding */ GraphQLNetworkException; }
/* harmony export */ });
/* unused harmony exports netError, gqlError */
/* harmony import */ var _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28813);

const getMessage = (param)=>{
    let { extensions: { errors  } , message  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors[0].message || message : message;
};
const getExtensionsErrors = (param)=>{
    let { path , code , extensions: { errors  }  } = param;
    return (errors === null || errors === void 0 ? void 0 : errors.length) > 0 ? errors.map((error)=>"graphql:".concat(path, ".").concat(error.type ? error.message : code)) : [
        "graphql:".concat(path, ".").concat(code)
    ];
};
const getExceptionFields = (originalError)=>[
        getMessage(originalError),
        originalError.code,
        getExtensionsErrors(originalError),
        originalError
    ];
/** @TODO: Extract class to ActionFailException */ class GraphQLNetworkException extends _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z {
}
const netError = (param)=>{
    let { networkError  } = param;
    return networkError ? new GraphQLNetworkException(networkError.message, networkError.code) : null;
};
const gqlError = (param)=>{
    let { graphQLErrors  } = param;
    return (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.length) > 0 ? new _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(...getExceptionFields(graphQLErrors[0])) : null;
};
const getOperationError = (err)=>err instanceof _utils_exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z ? err : gqlError(err) || netError(err);
/* harmony default export */ __webpack_exports__["ZP"] = (getOperationError);


/***/ }),

/***/ 46835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sT": function() { return /* binding */ getTrialById; },
  "WB": function() { return /* binding */ requestFreeTrial; },
  "Vs": function() { return /* binding */ startFreeTrial; }
});

// UNUSED EXPORTS: exchangeTrial

// EXTERNAL MODULE: ./src/apollo/index.js + 14 modules
var apollo = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 15 modules
var lib = __webpack_require__(4969);
;// CONCATENATED MODULE: ./src/graphql/mutations/requestTrial.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation requestTrial($email: String!) {\n		requestTrial(email: $email) {\n			... on RequestTrialSuccess {\n				trialId\n				isAuthorized\n				token\n				refreshToken\n			}\n			... on RequestTrialFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var requestTrial = ((0,lib/* default */.ZP)(_templateObject()));
const readRequestTrialResult = (param)=>{
    let { data  } = param;
    return data && {
        ...data.requestTrial
    };
};

;// CONCATENATED MODULE: ./src/graphql/mutations/startTrial.js

function startTrial_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation startTrial($trialId: String!, $extension: JSONObject) {\n		startTrial(trialId: $trialId, extension: $extension) {\n			... on StartTrialSuccess {\n				subscription {\n					id\n				}\n				trialStatus\n			}\n			... on StartTrialFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    startTrial_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var startTrial = ((0,lib/* default */.ZP)(startTrial_templateObject()));
const readStartTrialResult = (param)=>{
    let { data  } = param;
    return data && {
        ...data.startTrial
    };
};

;// CONCATENATED MODULE: ./src/graphql/mutations/trialExchange.js

function trialExchange_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	mutation trialExchange($requestAccessToken: String!) {\n		exchangeTrial(requestAccessToken: $requestAccessToken) {\n			... on ExchangeTrialSuccess {\n				trialId\n				token\n				refreshToken\n			}\n			... on ExchangeTrialFailure {\n				errorCode\n				message\n			}\n		}\n	}\n"
    ]);
    trialExchange_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutations_trialExchange = ((0,lib/* default */.ZP)(trialExchange_templateObject()));
const trialExchange_readTrialExchangeResult = (param)=>{
    let { data  } = param;
    return data && {
        ...data.exchangeTrial
    };
};

;// CONCATENATED MODULE: ./src/graphql/queries/getTrial.js

function getTrial_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n	query getTrialQuery($trialId: String!) {\n		getTrialById(trialId: $trialId) {\n			id\n		}\n	}\n"
    ]);
    getTrial_templateObject = function() {
        return data;
    };
    return data;
}

/* harmony default export */ var getTrial = ((0,lib/* default */.ZP)(getTrial_templateObject()));
const readTrial = (param)=>{
    let { data  } = param;
    return data && data.getTrialById;
};

;// CONCATENATED MODULE: ./src/services/trial.js





const requestFreeTrial = (param, turingToken)=>{
    let { email  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: requestTrial,
        variables: {
            email
        },
        context: {
            headers: {
                "x-turing-token": turingToken
            }
        }
    }).then(readRequestTrialResult);
};
const startFreeTrial = (param)=>{
    let { trialId , usageSelect , roleSelect , labName  } = param;
    return (0,apollo/* default */.Z)().mutate({
        mutation: startTrial,
        variables: {
            trialId,
            extension: {
                groupName: labName,
                usageSelect,
                roleSelect
            }
        }
    }).then(readStartTrialResult);
};
const exchangeTrial = (requestAccessToken, req, res)=>apolloClient({
        req,
        res
    }).mutate({
        mutation: trialExchange,
        variables: {
            requestAccessToken
        }
    }).then(readTrialExchangeResult);
const getTrialById = (context)=>(0,apollo/* default */.Z)(context).query({
        query: getTrial,
        variables: {
            trialId: context.query.trialId
        }
    }).then(readTrial);


/***/ }),

/***/ 3812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_Alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3074);
/* harmony import */ var _insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73972);





const FlashMessage = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        status: "error",
        className: "mb-4",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_Html__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            Tag: "span",
            children: text
        })
    });
};
FlashMessage.propTypes = {
    text: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FlashMessage);


/***/ }),

/***/ 28813:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
class ActionFailException extends Error {
    /** @constructor
	 * @type {(message: string, code: null | string | number, stack: string[], originalError: Error)}
	 */ constructor(message, code = null, stack = [], originalError = {}){
        super("ActionFailException");
        this.name = this.constructor.name;
        this.code = code;
        this.message = message;
        /** @TODO: rename `stack` field to `details` */ this.stack = stack;
        this.originalError = originalError;
        this.localeMessage = this.stack[0] || this.message;
    }
}
/* harmony default export */ __webpack_exports__["Z"] = (ActionFailException);


/***/ }),

/***/ 4116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37894);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10455);
/* harmony import */ var _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28813);





const actionFallback = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((err)=>{
        if (!(err instanceof _exceptions_ActionFailException__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)) {
            // rethrowing err if it's not an ActionFailException
            throw err;
        }
        // suppressing ActionFailException
        setResultStatus({
            errors: err,
            hasErrors: true
        });
    });
const actionSuccess = (setResultStatus)=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((result)=>{
        setResultStatus({
            result,
            errors: {},
            hasErrors: false
        });
        return result;
    });
const actionEnhancer = (setResultStatus)=>(0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_4__/* .compose */ .qC)(actionFallback(setResultStatus), actionSuccess(setResultStatus));
const getInitialState = ()=>({
        errors: {},
        hasErrors: false,
        result: undefined
    });
const useUniEffect = react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useResultStatus(action) {
    const unmounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const [resultStatus, setResultStatus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(getInitialState);
    const statusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    statusRef.current = resultStatus;
    useUniEffect(()=>()=>{
            unmounted.current = true;
        }, []);
    const updateResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((result)=>{
        if (unmounted.current) return;
        setResultStatus(result);
    }, []);
    const withResultStatus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>actionEnhancer(updateResultStatus)(// fallback decorator
        function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            setResultStatus(getInitialState);
            return action(...args);
        }), [
        action
    ]);
    const resetResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        if (statusRef.current.hasErrors) {
            // if there is no error, so there is no need to reset status
            setResultStatus(getInitialState);
        }
    }, []);
    return [
        withResultStatus,
        resultStatus,
        resetResult
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useResultStatus);


/***/ }),

/***/ 85562:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_IMAGE_SECURE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_TWITTER_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","SUBMIT":"Get Started","TITLE":"Start Your 30-day SnapGene Free Trial","SUB_TITLE":"No credit card is required.","AGREEMENT":"By clicking the button I agree to SnapGene\'s <a href=\'{{tosLink}}\'>Terms of Use</a> and <a href=\'{{ppLink}}\'>Privacy Policy</a>","CONFIRM_EMAIL_HEADING":"Thanks for signing up!","CONFIRM_EMAIL_PARAGRAPH":"Check your email for further instructions...","PAGE_TITLE":"Free Trial - SnapGene","CONFIRM_EMAIL_PAGE_TITLE":"Thank You for Free Trial Request - SnapGene","META":{"LOCALE":"en_US","TYPE":"article","TITLE":"SnapGene Free Trial | Software for everyday molecular biology","DESCRIPTION":"Try the full version of SnapGene for 30 days. One trial is allowed per computer. Your files will remain accessible with the free SnapGene Viewer.","URL":"https://www.snapgene.com/free-trial","CANONICAL":"https://www.snapgene.com/free-trial","SITE_NAME":"SnapGene","ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","TWITTER_SITE":"@SnapGene","TWITTER_CARD":"summary_large_image","TWITTER_CREATOR":"@SnapGene"},"errors":{"EMAIL_REQUIRED":"Please enter your email.","WRONG_EMAIL":"Please enter valid email.","EMAIL_INVALID_LENGTH":"Please enter valid email (up to 64 characters).","EXPIRED_TOKEN":"Your Trial Link is invalid - but that’s no problem. Just sign up for the trial again below to get a new registration link.","TURING_TEST_FAILED":"Incorrect response, please try again."}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,8930,7399,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(13932); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);